<template>
  <modal :show.sync="show" :on-close="onClose">
    <div class="column content-box">
      <woot-modal-header
        :header-title="$t('AGENT_BOT_MANAGEMENT.EDIT.HEADER_TITLE')"
        :header-content="$t('AGENT_BOT_MANAGEMENT.EDIT.HEADER_CONTENT')"
      />
      <agent-bot-form
        :is-submitting="loading"
        @submit="updateAgentBot"
        :on-close="onClose"
        :value="bot"     
      />
    </div>
  </modal>
</template>

<script>
import Modal from '../../../../components/Modal';
import alertMixin from 'shared/mixins/alertMixin';
import AgentBotForm from './Form';


export default {
  components: {
    Modal,
    AgentBotForm
  },
  mixins: [alertMixin],
  props: {
    bot: {
      type: Object,
      default: () => null,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      show: true,
    };
  },
  methods: {
    updateAgentBot(formData) {
      this.loading = true;
      this.$store
        .dispatch('updateAgentBotManagement', { id: this.bot.id, formData })
        .then(() => {
          this.loading = false;
          this.showAlert(this.$t('AGENT_BOT_MANAGEMENT.EDIT.SUCCESS'));
          this.onClose();
        })
        .catch(error => {
          this.loading = false;
          const errorMessage =
            error?.message || this.$t('AGENT_BOT_MANAGEMENT.EDIT.ERROR');
          this.showAlert(errorMessage);
        });
    },
  },
};
</script>
